import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { getAllContact } from "../../../api/RazorpayXAPI";
import ContactModal from "./ContactModal";
import { postAddEmployee } from "../../../api/RazorpayXAPI"; // Import your API function
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const AddContacts = () => {
  const { connected_accounts: connectedAccounts } = useSelector(
    (state) => state.connectedAccountData
  );
  const connectingCredentials = connectedAccounts
    ? connectedAccounts.hasOwnProperty("RazorPayX")
      ? connectedAccounts["RazorPayX"]
      : null
    : null;

  const [contactsData, setContactsData] = useState([]);
  const [isContactModalOpen, setContactModalOpen] = useState(false);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const contactsResponse = await getAllContact(
          connectingCredentials.usr,
          connectingCredentials.pwd
        );
        setContactsData(contactsResponse.data.items);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
    };

    fetchContacts();
  }, [connectingCredentials.usr, connectingCredentials.pwd]);

  const handleContactModalClose = () => {
    // Your custom logic here, if needed
    setContactModalOpen(false);
  };

  const handleSubmit = async (formData) => {
    try {
      const response = await postAddEmployee(
        connectingCredentials.usr,
        connectingCredentials.pwd,
        formData
      );

      // Log the response or handle it as needed
      console.log(response);

      // Update the state with the new data
      setContactsData([...contactsData, formData]);

      // Close the modal after successful submission
      handleContactModalClose();
    } catch (error) {
      console.error("Error submitting contact:", error);
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 15,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <div className="page-container">
      <Card
        variant="outlined"
        sx={{ border: "1px solid lightgray" }}
        className="shadow-sm"
      >
        <CardHeader
          title="Contact List"
          sx={{ margin: "15px" }}
          action={
            <div style={{ display: "flex" }}>
              <Button
                variant="contained"
                size="medium"
                style={{
                  backgroundColor: "#050092",
                  color: "#fff",
                }}
                onClick={() => setContactModalOpen(true)}
              >
                Add Contact
              </Button>
            </div>
          }
        />

        <Divider sx={{ backgroundColor: "darkgray" }} />
        <CardContent style={{ backgroundColor: "#F5F8FB" }}>
          {/* Table for displaying contacts */}
          <TableContainer component={Paper} sx={{ width: 1500 }} style={{marginLeft:"30px"}}>
            <Table sx={{ width: 1500 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                <StyledTableCell>ID</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell align="right" >Contact</StyledTableCell>
                  <StyledTableCell align="right">Email</StyledTableCell>
                  <StyledTableCell align="right">Type</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contactsData.map((contact) => (
                  <StyledTableRow key={contact.id}>
                    <StyledTableCell component="th" scope="row">
                      {contact.id || ""}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {contact.name || ""}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {contact.contact || ""}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {contact.email || ""}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {contact.type || ""}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <ContactModal
        open={isContactModalOpen}
        onClose={handleContactModalClose}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddContacts;
